<section class="container-privacy-policy--xs">
  <h1 class="h2-like">Politique de confidentialité</h1>
  <h2 class="h3-like">Politique de confidentialité</h2>
  <p>
    Nous comprenons l'importance de la protection de vos informations
    personnelles. Cette politique de confidentialité décrit les pratiques de
    collecte, d'utilisation et de protection de vos informations personnelles
    sur notre site web <strong>ubilaw.com</strong>.
  </p>

  <h2 class="h3-like">Collecte d'informations</h2>
  <p>
    Nous ne collectons que les informations minimales nécessaires pour fournir
    une expérience utilisateur optimale. Nous utilisons un cookie Google
    Analytics pour suivre les habitudes de navigation des utilisateurs sur notre
    site web. Ce cookie ne collecte aucune information personnelle identifiable.
  </p>

  <h2 class="h3-like">Utilisation de vos informations</h2>
  <p>
    Nous n'utilisons pas vos informations personnelles à des fins commerciales.
    Nous utilisons les informations collectées uniquement pour améliorer votre
    expérience sur notre site web <strong>ubilaw.com</strong>.
  </p>

  <h2 class="h3-like">Protection de vos informations</h2>
  <p>
    Nous prenons des mesures de sécurité pour protéger vos informations
    personnelles contre la perte, la falsification, l'utilisation abusive et
    l'accès non autorisé. Nous maintenons également des politiques strictes de
    confidentialité pour nos employés et prestataires de services qui ont accès
    à vos informations.
  </p>

  <h2 class="h3-like">Modifications apportées à cette politique</h2>
  <p>
    Nous nous réservons le droit de modifier cette politique de confidentialité
    à tout moment. Toutes les modifications seront publiées sur cette page. Nous
    vous encourageons à consulter régulièrement cette page pour prendre
    connaissance des éventuelles modifications.
  </p>

  <h2 class="h3-like">Contactez-nous</h2>
  <p>
    Si vous avez des questions sur cette politique de confidentialité, veuillez
    nous contacter par mail à l'adresse contact[at]ubilaw.com.
    Nous nous efforcerons de répondre à vos demandes dans les plus brefs délais.
  </p>
</section>
